import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=a5f15b54&scoped=true&lang=pug"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=a5f15b54&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f15b54",
  null
  
)

export default component.exports